import { render } from "./PatientDashBoard.vue?vue&type=template&id=35f32c51"
import script from "./PatientDashBoard.vue?vue&type=script&lang=js"
export * from "./PatientDashBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__